import { inject, Injectable } from '@angular/core';
import { AccountRepository } from '../repositories/account.repository';
import { Collector } from '@softapps/wws/pos-core';

@Injectable()
export class AccountService {
  readonly #repository = inject(AccountRepository);

  retrieveCollectors(accountId: number): Promise<Collector[]> {
    return this.#repository.collectors(accountId);
  }
}
